import React from "react";

import "./Steps.css";
import { useTranslation } from "react-i18next";

interface RfrInputPhoneProps {
    label: string,
    required?: boolean,
    name: string,
    className?: string,
    onInput?: (e) => void,
    data?: Record<string, unknown>,
    noDyanmicInput?: boolean;
    noPadding?: boolean;
    backSpaceEnabled?: boolean;
    disabled?: boolean;
    isError?: boolean;
}

export default function RfrInputPhone(props: RfrInputPhoneProps) {

    const { t } = useTranslation("login");

    const handleInputData = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        let newvalue = value.replace(/[^0-9]/g, '');
        if (newvalue.length > 10) {
            newvalue = newvalue.slice(0, 10);
        }
        event.target.value = newvalue;
        props.onInput(event);
    }

    const formatPhone = (phone) => {
        const length = phone.length;
        let formatted = phone;
        if (length < 10) {
            for (let i = 0; i < 10 - length; i++) {
                formatted += "_";
            }
        }
        formatted = "" + formatted.substring(0, 3) + " " + formatted.substring(3, 6) + "-" + formatted.substring(6, 10);
        return formatted;
    }

    const backspace = (event) => {
        if(props.backSpaceEnabled && event.keyCode === 8) {
            const phone: string = props.data[props.name] as string;
            const newPhone = phone.substring(0, phone.length - 1);
            event.target.value = newPhone;
            props.onInput(event);
        }
    }

    return (
        <>
            <div className={`rfr-form-row ${props.noPadding && "no-pad"}`}>
                {props.label && <div className="rfr-form-row-desc">
                    {props.required ?
                        <div className="row-desc-required">*</div>
                        :
                        <div className="row-desc-required"></div>
                    }
                    <div className="max-wdith-desc">
                        <label htmlFor={props.name} className="font-blue">{props.label}:</label>
                    </div>
                </div>}
                <div className="rfr-input-block">
                    {!props.noDyanmicInput ? (
                        <>
                            <input disabled={props.disabled} onKeyDown={(e) => {backspace(e)}} onChange={(e) => handleInputData(e)} type="text" name={props.name} id={props.name} className={`rfr-form-input-phone ${props.isError && "phone-error"}` } value={formatPhone(props.data[props.name])} />
                            {t("6-phone-ext")}
                            <input disabled={props.disabled} onChange={(e) => handleInputData(e)} type="text" name={props.name + "Ext"} id={props.name + "Ext"} className="rfr-form-input-short" value={props.data[props.name + "Ext"]} />
                        </>
                    ) : (
                        <>
                            <input disabled={props.disabled} onChange={(e) => handleInputData(e)} type="text" name={props.name} id={props.name} className="rfr-form-input-phone" />
                            {t("6-phone-ext")}
                            <input disabled={props.disabled} onChange={(e) => handleInputData(e)} type="text" name={props.name + "Ext"} id={props.name + "Ext"} className="rfr-form-input-short" />
                        </>
                    )}

                </div>
            </div>
        </>
    )
}